module.exports = __webpack_public_path__ + "static/space-aa2f51531cfe9ef30ff71d326064d4b0.jpg";